import { usePermissions } from '@/features/auth';
import type { Vehicle } from '@/features/vehiclesearch';
import { useExistingAgreementCheck } from '../../../hooks/useExistingAgreementCheck';
import { ExistingAgreementNotice } from './ExistingAgreementNotice';

export function LookupAgreementNotice({ vehicle }: { vehicle: Vehicle }) {
    const { hasPermission } = usePermissions();
    const canCheck = hasPermission({ resource: 'quote', action: 'add' });
    const checkState = useExistingAgreementCheck(canCheck ? vehicle : null);

    return (
        <ExistingAgreementNotice
            variant="lookup"
            checkState={checkState}
            canViewAgreement={hasPermission({ resource: 'agreement', action: 'read' })}
        />
    );
}
